import React, { FC } from 'react';

import { TeamTooltip } from '../../TeamTooltip';

import { Member } from '@/shared/api/organization';
import { AvatarBadge, Checkbox, LastActive, TeamStatus, TooltipWrapperDisabled } from '@/shared/ui';

type TeamSectionRowProps = {
    member: Member;
    isSelected: boolean;
    onSelect: (member: Member) => void;
    disableOperations?: boolean;
};

export const TeamSectionRow: FC<TeamSectionRowProps> = ({
    member,
    isSelected,
    onSelect,
    disableOperations,
}) => {
    const { name, email, role, status, lastActive, lastSeen } = member;

    return (
        <>
            <tr className='h-[72px] border-t border-opaque bg-background-primary hover:bg-background-secondary [&>td]:px-4'>
                <td className='!pl-5'>
                    {disableOperations ? (
                        <TooltipWrapperDisabled component={<Checkbox disabled />} />
                    ) : (
                        <Checkbox checked={isSelected} onChange={() => onSelect(member)} />
                    )}
                </td>
                <td>
                    <div className='flex items-center gap-3'>
                        <AvatarBadge name={name} /> {name}
                    </div>
                </td>
                <td>
                    <div>{email}</div>
                </td>
                <td>
                    <div>
                        <TeamStatus role={role} />
                    </div>
                </td>
                <td>
                    <div>
                        <TeamStatus status={status} />
                    </div>
                </td>
                <td>
                    <div>
                        <LastActive lastActive={lastActive!} lastSeen={lastSeen!} />
                    </div>
                </td>
                <td>
                    <div className='flex justify-end gap-5 mr-6'>
                        <TeamTooltip email={email} name={name} disabled={disableOperations} />
                    </div>
                </td>
            </tr>
        </>
    );
};
